import type { IntlShape } from 'react-intl';
import * as yup from 'yup';

export type BankDetailsFormValues = { accountNumber: string; sortCode: string };

export const createBankDetailsSchema = (intl: IntlShape) => {
    return yup.object({
        accountNumber: yup
            .string()
            .defined()
            .test(
                'account-number-length',
                intl.formatMessage({
                    id: '_.link_bank_account.required_field',
                    defaultMessage: 'Required field'
                }),
                (value) => !!value && value.length === 8
            ),
        sortCode: yup
            .string()
            .defined()
            .test(
                'sort-code-length',
                intl.formatMessage({
                    id: '_.link_bank_account.required_field',
                    defaultMessage: 'Required field'
                }),
                (value) => !!value && value.length === 8
            )
    });
};
